import './Page404.scss'

const Page404 = () => {}

export default Page404
